module.exports = __webpack_public_path__ + "45c297e3d7f81b420d2ecdb371e822ba.pdf";